import axios from "axios";
import qs from "qs";

export const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});

// Interceptor de request: agregar token JWT
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  return config;
});

// Interceptor de respuesta: si 401, limpiar sesión y redirigir
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      if (window.location.pathname !== "/" && window.location.pathname !== "/login" && window.location.pathname !== "/reset-password") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

/**
 * Llama a /me y sobreescribe localStorage con los datos reales del servidor.
 * Usar al montar la app (App.vue o layout principal).
 */
export function syncMe() {
  return apiClient.get("/me").then((response) => {
    const serverUser = response.data.data.user;
    let current = {};
    try { current = JSON.parse(localStorage.getItem("user") || "{}"); } catch { current = {}; }
    const merged = { ...serverUser, periodo_selected: current.periodo_selected, periodo_id: current.periodo_id };
    localStorage.setItem("user", JSON.stringify(merged));
    return merged;
  }).catch((err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    }
    return null;
  });
}

export default {
  login(user) {
    return apiClient.post("/login", user);
  },
  logout(user) {
    return apiClient.post("/logout", user);
  },
  get(payload) {
    if (payload.data) {
      return apiClient.get(payload.url, {params:payload.data});
    }else {
      return apiClient.get(payload.url);
    }
  },
  post(payload) {
    return apiClient.post(payload.url, qs.stringify(payload.data));
  },
  put(payload) {
    return apiClient.put(payload.url, qs.stringify(payload.data));
  },
  delete(payload) {
    return apiClient.delete(payload.url);
  },
  getFile(data) {
    return apiClient.get("/documentos/" + data.data + "/file/" + data.perito_id + "/" + data.periodo_id
     ,{
       responseType: "arraybuffer"
      }
    );
  },
  deleteFile(data) {
    return apiClient.delete("/documentos/" + data.data + "/file/" + data.perito_id + "/" + data.periodo_id);
  },

  getPdf(payload) {
    return apiClient.get(payload.url, {
      responseType: "arraybuffer"
    });
  },
  getExcel(payload) {
    return apiClient.get(payload.url, {
      responseType: "arraybuffer"
    });
  },
};
